import type { ReviewStatus } from './consoleApi';

// Kit soft-pill vocabulary (aligned with the app's success/warning/flagged tokens).
const META: Record<ReviewStatus, { label: string; className: string }> = {
  signed: { label: 'Signed', className: 'bg-success-soft text-success' },
  pending: { label: 'Pending', className: 'bg-warning-soft text-warning' },
  stale: { label: 'Re-review', className: 'bg-warning-soft text-warning' },
  changes_requested: { label: 'Changes requested', className: 'bg-flagged-soft text-flagged' },
};

// Accept an arbitrary string, not just the known ReviewStatus union, so the
// neutral fallback is genuinely reachable if the backend ever returns a status
// the console doesn't model yet (rather than being dead code).
export function statusBadgeMeta(status: ReviewStatus | string): { label: string; className: string } {
  return META[status as ReviewStatus] ?? { label: status, className: 'bg-surface-sunken text-text-secondary' };
}
